import * as React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../../utils/moment";

import styles from "../../styles/createTest/CreateTestSideNav.css";

export class Step extends React.PureComponent {
    static propTypes = {
        label: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired,
        isComplete: PropTypes.bool.isRequired,
        isCurrent: PropTypes.bool.isRequired,
        isEnabled: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired
    };

    render() {
        const liClasses = [
            styles.step,
            this.props.isComplete ? styles.stepComplete : styles.stepIncomplete,
            this.props.isCurrent ? styles.stepActive : styles.stepInactive,
            this.props.isEnabled ? styles.stepEnabled : styles.stepDisabled
        ];
        const liClassName = liClasses.filter(Boolean).join(" ");

        let icon;
        if (this.props.isCurrent) {
            icon = ["far", "chevron-circle-right"];
        } else if (this.props.isComplete) {
            icon = ["fas", "check-circle"];
        } else {
            icon = ["far", "circle"];
        }

        // We only register the onClick handler if the step is enabled and it's not the current step
        const onClick =
            this.props.isEnabled && !this.props.isCurrent && this.props.onClick;

        return (
            <li
                key={`step-${this.props.index}`}
                className={liClassName}
                onClick={onClick}
            >
                <div className={styles.stepWrapper}>
                    <div className={styles.stepIcon}>
                        <FontAwesomeIcon icon={icon} />
                    </div>
                    <p className={styles.stepLabel}>{this.props.label}</p>
                </div>
            </li>
        );
    }
}

export default class CreateTestSideNav extends React.PureComponent {
    static propTypes = {
        // wevo: PropTypes.object,
        currentStep: PropTypes.number.isRequired,
        steps: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                isEnabled: PropTypes.bool.isRequired,
                isComplete: PropTypes.bool.isRequired
            })
        ).isRequired,
        onSaveAndExit: PropTypes.func.isRequired,
        onStepClick: PropTypes.func.isRequired
    };

    static defaultProps = {};

    render() {
        const steps = [];

        let priorStepsAreComplete = true;
        this.props.steps.forEach((step, index) => {
            const isCurrent = this.props.currentStep === index;
            steps.push(
                <Step
                    key={step.label}
                    label={step.label}
                    index={index}
                    isComplete={step.isComplete}
                    isCurrent={isCurrent}
                    isEnabled={step.isEnabled}
                    onClick={() => this.props.onStepClick(index)}
                />
            );
            priorStepsAreComplete = priorStepsAreComplete && step.isComplete;
        });

        const saveEnabled = this.props.steps.some(step => step.isComplete);

        return (
            <div className={styles.sideNav}>
                <div className={styles.stepsWrapper}>
                    <ol className={styles.steps}>{steps}</ol>
                </div>
                <button
                    className={styles.saveAndExit}
                    disabled={!saveEnabled}
                    onClick={this.props.onSaveAndExit}
                >
                    <div className={styles.icon}>
                        <FontAwesomeIcon icon={["fas", "long-arrow-right"]} />
                    </div>
                    <p className={styles.label}>Save &amp; Exit</p>
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/CreateTestSideNav.js